import { render, staticRenderFns } from "./Sliderbudget.vue?vue&type=template&id=a6b018ca&scoped=true&"
import script from "./Sliderbudget.vue?vue&type=script&lang=js&"
export * from "./Sliderbudget.vue?vue&type=script&lang=js&"
import style0 from "./Sliderbudget.vue?vue&type=style&index=0&id=a6b018ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b018ca",
  null
  
)

export default component.exports